import '../../resources/sass/app.scss'
import App from "./components/signup/App.vue";
import router from './signupRouter.js'
import { createAppWithTheme } from './createApp.js'

const app = createAppWithTheme(App, router)

app.use(router)
app.mount('#app')

import $ from "jquery";

window.$ = $
window.JQuery = $
